export default __webpack_public_path__ + "static/media/2.10.87ae3d61.mp3";